<template>
  <div class="row">
    <div class="col-md-4 col-sm-12">
      <Jumbotron>
        <div class="d-flex mt-2">
          <img src="../assets/svg/flag.svg" alt="" srcset="" width="30" class="mb-3" />
          <h4 class="heading ms-3">Module Center</h4>
          <Button label="Create" class="qb-btn qb-btn-primary-md ms-auto" @onClick="toggleCreateModuleModal" />
        </div>
        <p class="sub-heading mb-2">
          Create and manage module. Task can be added to the module if the module is created or select the module to add
          task.
        </p>
      </Jumbotron>

      <Card class="row mt-3 px-0 mx-0">
        <div class="col-12 px-2">
          <div class="">
            <Badge label="Filter Module" class="badge-neon badge-neon-grey-outline" />
            <div class="row mt-2">
              <div class="col-6">
                <Select nullValueName="All Category" :options="categoryList" v-model="filter.categoryId" />
              </div>
            </div>
          </div>
        </div>
        <hr class="divider mt-3 mb-2" />
        <div class="col-12 px-2">
          <div class="">
            <Input placeholder="Enter the module name to search" label="Search Module" type="text" v-model="moduleSearchTerm" />
          </div>
        </div>
        <hr class="divider mt-3" />
        <div class="col-12 px-1">
          <div class="module-area">
            <div v-if="moduleList.length === 0">
              <p class="module-select-toggle-text mx-auto mt-4">Module's not found!</p>
            </div>
            <div v-else>
              <ModuleList
                v-for="(module, index) in moduleList"
                :key="index"
                :module="module"
                :index="index"
                @onClick="handleFilterModule"
                :lastIndex="moduleList.length"
              />
            </div>
          </div>
        </div>
        <hr class="divider mx-0" />
      </Card>

      <Modal @close="toggleCreateModuleModal" :modalActive="moduleCreateModalActive">
        <h4 class="modal-heading">Create Module</h4>
        <Input
          placeholder="Enter the module name"
          label="Module Name *"
          class="mt-3"
          type="text"
          v-model="module.name"
        />
         <p class="info-label mt-2">
          Ex., Java is a module
        </p>
        <p class="info-label mt-2">
          <font-awesome-icon icon="fa-solid fa-circle-info" />Name should be from 2 to 60 characters!
        </p>
        <TextArea
          placeholder="Enter the module description"
          label="Module Description *"
          class="mt-3"
          v-model="module.description"
        />
        <p class="info-label">
          <font-awesome-icon icon="fa-solid fa-circle-info" />Description should be from 10 to 100 characters!
        </p>

        <div class="info d-flex gap-3 p-3 mt-2 mb-0">
          <div><font-awesome-icon icon="fa-solid fa-circle-exclamation" /></div><p class="my-0 fade-text"> To create a new category, Enter the module name and click "+ create new" that appears below</p>
        </div>

        <div class="row justify-content-between align-items-end mt-3">
          <div class="col-7">
            <SearchDropDown
              label="Module Category *"
              :selectLabel="module.category.name || 'Select Module Category'"
              placeholder="Find or Create Category"
              v-model="categorySearchTerm"
              @callBackValue="handleCategory"
              :items="categoryList"
              :create="true"
              :showAddOption="categoryList && categoryList.length === 0"
              @callBackCreate="handleCreateCategory"
            />
            <p class="info-label mt-2">
          Ex., Backend is a category
        </p>
        
          </div>
          <div class="col-5">
            <p class="create-category-info"><font-awesome-icon icon="fa-solid fa-circle-info" /> If Category not found,enter the module name and click create new</p>
          </div>
           <!-- <p class="info-label">
          <font-awesome-icon icon="fa-solid fa-circle-info" />If module not found,enter the module name and click create new
        </p> -->
        </div>
        <Button
          label="Create"
          class="qb-btn qb-btn-primary-md mt-4"
          @onClick="createModule()"
          :disabled="!validateModule"
        />
      </Modal>
      <Modal @close="toggleEditModuleModal" :modalActive="moduleEditModalActive">
        <h4 class="modal-heading">Edit Module</h4>
        <Input
          placeholder="Enter the module name"
          label="Module Name *"
          class="mt-3"
          type="text"
          v-model="module.name"
        />
        <p class="info-label mt-2">
          <font-awesome-icon icon="fa-solid fa-circle-info" />Name should be from 2 to 60 characters!
        </p>
        <TextArea
          placeholder="Enter the module description"
          label="Module Description *"
          class="mt-3"
          v-model="module.description"
        />
        <p class="info-label">
          <font-awesome-icon icon="fa-solid fa-circle-info" />Description should be from 10 to 100 characters!
        </p>
        <div class="row justify-content-between align-items-end mt-3">
          <div class="col-7">
            <SearchDropDown
              label="Module Category *"
              :selectLabel="module.category.name || 'Select Module Category'"
              placeholder="Enter Category to search"
              v-model="categorySearchTerm"
              @callBackValue="handleCategory"
              :items="categoryList"
              :create="true"
              :showAddOption="categoryList && categoryList.length === 0"
              @callBackCreate="handleCreateCategory"
            />
          </div>
          <div class="col-5">
            <p class="create-category-info"><font-awesome-icon icon="fa-solid fa-circle-info" /> If Category not found,enter the module name and click create new</p>
          </div>
        </div>
        <Button
          label="Save"
          class="qb-btn qb-btn-primary-md mt-4"
          @onClick="saveModule()"
          :disabled="!validateModule"
        />
      </Modal>
    </div>
    <div class="col-md-8 col-sm-12">
      <div class="row">
        <div class="col-12">
          <Card class="task-detail-layout d-flex flex-column justify-content-between">
            <div>
              <div class="task-detail-layout-header">
                <div v-if="!checkModuleAvailability">
                  <Button
                    label="View All Task"
                    :class="['qb-btn', { 'qb-btn-black-sm': isViewAllTask }, { 'qb-btn-outline-sm': !isViewAllTask }]"
                    @onClick="isViewAllTask = true"
                  />
                </div>
                <div v-else>
                  <p class="module-select-toggle-text">Select Module</p>
                </div>
              </div>
              <div class="task-detail-layout-body">
                <p class="task-select-toggle-text mx-auto" v-if="checkModuleAvailability">
                  Select the module to view tasks
                </p>
                <div v-else>
                  <div class="d-flex module-data justify-content-between">
                    <div>
                      <div class="d-flex gap-3 align-items-center mb-2">
                        <div class="module-icon-cover">
                          <font-awesome-icon icon="fa-solid fa-list-check" />
                        </div>
                        <div>
                          <h4 class="module-data-header-title">{{ selectedModule.name }}</h4>
                          <Badge
                            :label="selectedModule.category.name"
                            class="badge-neon badge-neon-warning-outline me-2 text-uppercase"
                          />
                          <Badge
                            :label="selectedModule.totalNumberOfTask + ' Tasks'"
                            class="badge-neon badge-neon-grey-outline"
                          />
                        </div>
                      </div>

                      <p class="module-data-header-label">Description</p>
                      <p class="module-data-header-subtitle">{{ selectedModule.description }}</p>

                      <!-- <p class="module-data-header-subtitle">Create at: {{ formatDate(()=>selectedModule.createdDate) }}</p> -->
                    </div>
                    <div><font-awesome-icon icon="fa-solid fa-pen-to-square" @click="toggleEditModuleModal" /></div>
                  </div>

                  <hr class="divider mt-3 mb-2" />

                  <div class="task-list-data">
                    <div class="mb-3">
                      <Button
                        v-if="isViewAllTask"
                        :class="[
                          'qb-btn ',
                          { 'qb-btn-black-sm': !isViewAllTask },
                          { 'qb-btn-outline-sm': isViewAllTask },
                        ]"
                        @onClick="addTask()"
                      >
                        <font-awesome-icon icon="fa-solid fa-plus" /> Add Task
                      </Button>
                      <Button
                        v-else
                        :class="[
                          'qb-btn ',
                          { 'qb-btn-black-sm': !isViewAllTask },
                          { 'qb-btn-outline-sm': isViewAllTask },
                        ]"
                        @onClick="isViewAllTask = true"
                      >
                        <font-awesome-icon icon="fa-solid fa-angle-left" /> Back
                      </Button>
                    </div>
                    <div>
                      <div class="task-list-layout">
                        <div class="task-list-layout-body">
                          <div v-if="isViewAllTask">
                            <div v-if="checkTaskListAvailability">
                              <TaskList
                                v-for="(data, index) in taskList"
                                :key="index"
                                :dayTask="data"
                                :index="index"
                                :lastIndex="taskList.length"
                                @onEdit="editTask"
                              />
                            </div>
                            <div v-else>
                              <p class="task-select-toggle-text mx-auto">No task found!</p>
                            </div>
                          </div>
                          <div v-else>
                            <TaskAction :data="editTaskData" @onSave="viewAllTask()" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="task-detail-layout-footer"></div>
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "../components/TextFieldComponent.vue";
import Button from "../components/ButtonComponent.vue";
import Select from "../components/SelectComponent.vue";
import Badge from "../components/BadgeComponent.vue";
import TextArea from "../components/TextAreaComponent.vue";
import SearchDropDown from "../components/DropDownSearchComponent.vue";
import Modal from "../components/ModalComponent.vue";
import Jumbotron from "../components/JumbotronComponent.vue";
import Card from "../components/CardComponent.vue";

// import ViewTaskComponent from "../components/ViewTaskComponent.vue";
import TaskAction from "../components/AddTaskComponent.vue";
import ModuleList from "../components/ModuleListComponent.vue";
import TaskList from "../components/TaskListComponent.vue";

import Vue from "vue";

import { createNamespacedHelpers } from "vuex";
const { mapActions: mapModuleActions, mapGetters } = createNamespacedHelpers("Module");
const { mapGetters: mapCategoryGetters, mapActions: mapCategoryActions } = createNamespacedHelpers("Category");

export default {
  name: "ModuleCenterPage",
  data() {
    return {
      moduleCreateModalActive: false,
      moduleEditModalActive: false,
      isViewAllTask: true,
      categorySearchTerm: "",
      moduleSearchTerm: "",
      filter: {
        categoryId: "",
        moduleId: "",
        selectedModuleName: "",
      },
      module: {
        name: "",
        description: "",
        category: {
          id: "",
          name: "",
        },
      },
      editTaskData: {},
    };
  },
  components: {
    Button,
    Input,
    Select,
    Badge,
    Modal,
    SearchDropDown,
    TaskList,
    TaskAction,
    ModuleList,
    TextArea,
    Jumbotron,
    Card,
  },
  computed: {
    ...mapCategoryGetters({
      categoryList: "getCategoryListOptions",
    }),
    ...mapGetters({
      selectedModuleId: "getSelectedModuleId",
      selectedModule: "getSelectedModule",
      moduleList: "getModuleList",
      taskList: "getTaskList",
    }),
    validateModule() {
      const validateName = this.module.name.length > 2 && this.module.name.length < 30;
      const validateDescription = this.module.description.length > 10 && this.module.description.length < 100;
      return validateName && validateDescription && this.module.category;
    },
    checkModuleAvailability() {
      return Object.keys(this.selectedModule).length === 0;
    },
    checkTaskListAvailability() {
      return this.taskList.length > 0;
    },
  },
  methods: {
    ...mapModuleActions({
      setSelectedModule: "SET_SELECTED_MODULE",
      getAllModule: "GET_ALL_MODULE",
      getTaskByModuleId: "GET_ALL_TASK_BY_MODULE_ID",
      createNewModule: "CREATE_NEW_MODULE",
      updateModule: "UPDATE_MODULE",
      getAllModuleByCategoryId: "GET_ALL_MODULE_BY_CATEGORY_ID",
      getModuleById: "GET_MODULE_BY_ID",
      setTaskList: "SET_TASK_LIST",
    }),
    ...mapCategoryActions({
      getAllCategory: "GET_ALL_CATEGORY",
      createCategory: "CREATE_NEW_CATEGORY",
    }),
    resetModuleCreation() {
      this.module = {
        name: "",
        description: "",
        category: {
          id: "",
          name: "",
        },
      };
    },
    toggleEditModuleModal() {
      if (this.moduleEditModalActive) {
        this.moduleEditModalActive = false;
        this.resetModuleCreation();
      } else {
        if (!this.checkModuleAvailability) {
          this.module = {
            name: this.selectedModule.name,
            description: this.selectedModule.description,
            category: {
              id: this.selectedModule.category.id,
              name: this.selectedModule.category.name,
            },
          };
        }
        this.moduleEditModalActive = true;
      }
    },
    toggleCreateModuleModal() {
      this.resetModuleCreation();
      this.categorySearchTerm = "";
      this.moduleCreateModalActive = !this.moduleCreateModalActive;
    },
    handleSearchDropDown() {
      this.toggleSearchDropDown = !this.toggleSearchDropDown;
    },
    handleCategory({ label, value }) {
      this.module.category.name = label;
      this.module.category.id = value;
    },
    handleCreateCategory() {
      this.createCategory({
        payload: this.categorySearchTerm,
        successCallback: ({ data }) => {
          if (data.status === "OK") {
            this.handleCategory({ label: data.data.name, value: data.data.id });
            this.getAllCategory({ name: this.categorySearchTerm });
            Vue.$toast.success("Category created!");
          } else {
            Vue.$toast.error("Category creation failed!");
          }
        },
        errorCallback: (err) => {
          Vue.$toast.error(err.message);
        },
      });
    },
    handleFilterModule(module) {
      this.filter.selectedModuleName = module.name;
      this.filter.moduleId = module.id;
      this.setSelectedModule(module);
      this.getTaskByModuleId(module.id);
      this.getModuleById();
    },
    createModule() {
      this.createNewModule({
        payload: {
          name: this.module.name,
          description: this.module.description,
          categoryId: this.module.category.id,
        },
        successCallback: ({ data }) => {
          if (data.status === "OK") {
            this.toggleCreateModuleModal();
            Vue.$toast.success("Module Created Successfully");
            this.resetModuleCreation();
          } else {
            Vue.$toast.error("Module Creation Failed");
          }
        },
        errorCallback: (err) => {
          Vue.$toast.error(err.message);
        },
      });
    },
    saveModule() {
      this.updateModule({
        payload: {
          name: this.module.name,
          description: this.module.description,
          categoryId: this.module.category.id,
          id: this.selectedModule.id,
        },
        successCallback: ({ data }) => {
          if (data.status === "OK") {
            this.toggleEditModuleModal();
            Vue.$toast.success("Module Updated Successfully");
            this.setSelectedModule(data.data);
          } else {
            Vue.$toast.error("Module Update Failed");
          }
        },
        errorCallback: (err) => {
          Vue.$toast.error(err.message);
        },
      });
    },
    addTask() {
      this.editTaskData = {};
      this.isViewAllTask = false;
    },
    editTask(data) {
      this.editTaskData = data;
      this.isViewAllTask = false;
    },
    viewAllTask(){
      console.log("save task successfull")
      this.isViewAllTask = true;
    }
  },
  watch: {
    "filter.categoryId": {
      handler: function (value) {
        if (!value) {
          this.getAllModule({ name: "" });
        } else {
          this.getAllModuleByCategoryId(value);
        }
        this.setSelectedModule({});
        this.filter.selectedModuleName = "";
      },
      deep: true,
    },
    moduleSearchTerm(name) {
      this.getAllModule({ name });
    },
    categorySearchTerm(name) {
      this.getAllCategory({ name });
    },
  },
  created() {
    this.setSelectedModule({});
    this.setTaskList([]);
    this.getAllCategory({ name: this.categorySearchTerm });
    this.getAllModule({ name: this.moduleSearchTerm });
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.module-icon-cover {
  padding: 20px;
  background-color: $light-fade-100;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: $field-border-radius;
}

.fa-list-check {
  color: $light-600;
  font-size: $font-size-xxl;
}

.fa-pen-to-square {
  color: $light-500;
  font-size: $font-size-lg;

  &:hover {
    color: $dark-200;
    cursor: pointer;
  }
}

.info-label {
  color: $light-500;
  font-size: $font-size-sm;
  font-weight: $font-weight-normal-1;
  margin: 0px;
}

.fa-circle-info {
  color: $light-400;
  font-size: $font-size-sm;
  margin-right: 5px;
}

.module-data {
  padding: 15px;
  padding-bottom: 5px;
}

.task-list-data {
  padding: 5px 10px 15px 10px;
}

.module-data-header-title {
  font-size: $font-size-xl;
  font-weight: $font-weight-bold;
  color: $dark-400;
  margin: 0px;
}

.module-data-header-subtitle {
  font-size: $font-size-sm;
  font-weight: $font-weight-normal-1;
  color: $light-600;
  margin: 0px;
}

.module-data-header-label {
  font-size: $font-size-md;
  font-weight: $font-weight-bold;
  color: $dark-200;
  margin: 0px;
}

.label--style {
  font-weight: $font-weight-normal-2;
  font-size: $font-size-md;
  // margin-top: 10px;
  margin-bottom: 10px;
}

.heading {
  font-size: $font-size-xxl;
  font-weight: 600;
}

.sub-heading {
  font-size: $font-size-md;
}

.modal-heading {
  font-size: $font-size-xxl;
  font-weight: 600;
}

.module-area {
  height: 370px;
  overflow-y: scroll;
  padding: 0px 5px;
  padding-top: 10px;
  border-radius: $field-border-radius;
}

.module-area::-webkit-scrollbar {
  background: none;
  width: 5px;
  border-radius: $field-border-radius;
}

.module-area::-webkit-scrollbar-thumb {
  background-color: $light-300;
  border-radius: $field-border-radius;
}

.create-category-info {
  margin-bottom: 5px;
  color: $light-600;
  font-weight: $font-weight-bolder;
  font-size: $font-size-sm;
  line-height: 16px;
}

.task-card {
  background-color: $white;
  padding: 10px 15px;
  border-radius: $field-border-radius;
  margin-bottom: 10px;

  &:hover {
    background-color: $light-100;
    cursor: pointer;
  }

  &.dragging {
    background-color: $light-200;
  }
}

.divider {
  border: 0.5px solid $light-500;
  margin: 0px;
}

.task-detail-layout {
  background-color: $white;
  border-radius: $field-border-radius;
  // border: 1px solid $light-200;
  min-height: 720px;
}

.task-detail-layout-header {
  // background-color: $light-100;
  padding: 8px 10px;
  border-bottom: 1px solid $light-200;
  border-top-left-radius: $field-border-radius;
  border-top-right-radius: $field-border-radius;
}

.task-detail-layout-footer {
  background-color: $light-100;
  padding: 8px 10px;
  border-top: 1px solid $light-200;
  border-bottom-left-radius: $field-border-radius;
  border-bottom-right-radius: $field-border-radius;
}

.task-detail-layout-body {
  // padding: 10px;
  max-height: 650px;
  // overflow: scroll;
}

.task-list-layout {
  background-color: $white;
  // border-radius: $field-border-radius;
  // border: 1px solid $light-200;
  min-height: 490px;
}

.task-list-layout-body {
  padding: 5px 10px;
  max-height: 490px;
  overflow: scroll;
}

.task-list-layout-body::-webkit-scrollbar {
  background: none;
  width: 5px;
}

.task-list-layout-body::-webkit-scrollbar-thumb {
  background-color: $light-300;
  border-radius: $field-border-radius;
}

// .task-detail-layout-body::-webkit-scrollbar {
//   background: none;
//   width: 5px;
// }

// .task-detail-layout-body::-webkit-scrollbar-thumb {
//   background-color: $light-300;
//   border-radius: $field-border-radius;
// }

.task-select-toggle-text {
  color: $light-500;
  font-size: $font-size-md;
  font-weight: $font-weight-normal-2;
  margin-top: 40px;
  width: fit-content;
}

.module-select-toggle-text {
  color: $light-500;
  font-size: $font-size-md;
  font-weight: $font-weight-normal-2;
  margin: 0px;
  width: fit-content;
}

.module-list-card {
  background-color: $white;
  padding: 8px 12px;
  border-radius: $field-border-radius;
  margin-bottom: 10px;
  border: 1px solid $light-200;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;

  &:hover {
    background-color: #fdfdfd;
    // cursor: pointer;
  }
}
.info{
  background-color: #fff9e9;
  border-radius:5px;
}
.fa-circle-exclamation{
  color:#fec12f;
}
.fade-text{
  color: $dark-200;
  font-size: $font-size-md;
  font-weight: $font-weight-normal-1;
  margin: 0px;
}
</style>
